module.exports = __webpack_public_path__ + "assets/img/Slice3.34d3ba58.png";